import { render } from "./PrefectureSelect.vue?vue&type=template&id=19139fca"
import script from "./PrefectureSelect.vue?vue&type=script&lang=js"
export * from "./PrefectureSelect.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src827224769/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__